import React, { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid,
  Chip,
  IconButton,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Avatar,
  Divider,
  Badge,
  Tooltip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Box,
  LinearProgress,
  CircularProgress,
  Alert,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemSecondaryAction
} from '@mui/material';
import {
  Search as SearchIcon,
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Share as ShareIcon,
  Download as DownloadIcon,
  Add as AddIcon,
  Assessment as ReportIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  TrendingUp as TrendingUpIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  CalendarToday as CalendarIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Link as LinkIcon,
  OpenInNew as OpenInNewIcon,
  Analytics as AnalyticsIcon,
  Group as GroupIcon,
  AttachMoney as MoneyIcon,
  Schedule as ScheduleIcon,
  Assessment as AssessmentIcon,
  Verified as VerifiedIcon,
  Gavel as GavelIcon,
  FactCheck as FactCheckIcon,
  AutoFixHigh as AutoFixHighIcon,
  Speed as SpeedIcon,
  ExpandMore as ExpandMoreIcon,
  PlayArrow as PlayIcon,
  Stop as StopIcon,
  Refresh as RefreshIcon,
  Print as PrintIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Security as SecurityIcon,
  Lock as LockIcon,
  Public as PublicIcon,
  History as HistoryIcon,
  TrendingDown as TrendingDownIcon,
  LocalAtm as AtmIcon,
  AccountBalanceWallet as WalletIcon,
  MonetizationOn as MonetizationIcon,
  PictureAsPdf as PdfIcon,
  Description as DocumentIcon,
  TableChart as TableIcon,
  ShowChart as ChartIcon,
  Timeline as TimelineIcon,
  DateRange as DateRangeIcon,
  FilterAlt as FilterAltIcon,
  GetApp as GetAppIcon,
  CloudDownload as CloudDownloadIcon,
  FileDownload as FileDownloadIcon,
  InsertDriveFile as FileIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  AudioFile as AudioIcon,
  Archive as ArchiveIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  Create as CreateIcon,
  Save as SaveIcon,
  Send as SendIcon,
  Schedule as ScheduleIcon2,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
  Help as HelpIcon,
  Info as InfoIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  MoreHoriz as MoreHorizIcon,
  MoreVert as MoreVertIcon2,
  Menu as MenuIcon,
  MenuOpen as MenuOpenIcon,
  Close as CloseIcon2,
  Minimize as MinimizeIcon,
  Maximize as MaximizeIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  FitScreen as FitScreenIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  CenterFocusWeak as CenterFocusWeakIcon,
  CropFree as CropFreeIcon,
  CropSquare as CropSquareIcon,
  Crop as CropIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  Flip as FlipIcon,
  Transform as TransformIcon,
  Straighten as StraightenIcon,
  Tune as TuneIcon,
  Adjust as AdjustIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Contrast as ContrastIcon,
  Palette as PaletteIcon,
  ColorLens as ColorLensIcon,
  Gradient as GradientIcon,
  Opacity as OpacityIcon,
  BlurOn as BlurOnIcon,
  BlurOff as BlurOffIcon,
  Filter as FilterIcon2,
  Filter1 as Filter1Icon,
  Filter2 as Filter2Icon,
  Filter3 as Filter3Icon,
  Filter4 as Filter4Icon,
  Filter5 as Filter5Icon,
  Filter6 as Filter6Icon,
  Filter7 as Filter7Icon,
  Filter8 as Filter8Icon,
  Filter9 as Filter9Icon,
  Filter9Plus as Filter9PlusIcon,
  FilterBAndW as FilterBAndWIcon,
  FilterCenterFocus as FilterCenterFocusIcon,
  FilterDrama as FilterDramaIcon,
  FilterFrames as FilterFramesIcon,
  FilterHdr as FilterHdrIcon,
  FilterNone as FilterNoneIcon,
  FilterTiltShift as FilterTiltShiftIcon,
  FilterVintage as FilterVintageIcon,
  Grain as GrainIcon,
  GridOn as GridOnIcon,
  GridOff as GridOffIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  ViewComfy as ViewComfyIcon,
  ViewCompact as ViewCompactIcon,
  ViewStream as ViewStreamIcon,
  ViewQuilt as ViewQuiltIcon,
  ViewCarousel as ViewCarouselIcon,
  ViewDay as ViewDayIcon,
  ViewWeek as ViewWeekIcon,
  ViewAgenda as ViewAgendaIcon,
  ViewHeadline as ViewHeadlineIcon,
  ViewSidebar as ViewSidebarIcon,
  ViewColumn as ViewColumnIcon,
  ViewArray as ViewArrayIcon,
  ViewKanban as ViewKanbanIcon,
  ViewTimeline as ViewTimelineIcon
} from '@mui/icons-material';
import Logo from '../common/Logo';
import {
  getReports,
  getReport,
  generateReport,
  downloadReport,
  toggleFavorite,
  deleteReport,
  Report,
  ReportStats
} from '../../services/reportApi';


const Reports: React.FC = () => {
  const [reports, setReports] = useState<Report[]>([]);
  const [filteredReports, setFilteredReports] = useState<Report[]>([]);
  const [stats, setStats] = useState<ReportStats>({
    total: 0,
    completed: 0,
    totalDownloads: 0,
    favorites: 0
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [formatFilter, setFormatFilter] = useState('all');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedReport, setSelectedReport] = useState<Report | null>(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [newReportTitle, setNewReportTitle] = useState('');
  const [newReportType, setNewReportType] = useState<'analytics' | 'financial' | 'performance' | 'custom' | ''>('analytics');
  const [newReportFormat, setNewReportFormat] = useState<'pdf' | 'excel' | 'csv' | 'json' | ''>('pdf');
  const [newReportStartDate, setNewReportStartDate] = useState('');
  const [newReportEndDate, setNewReportEndDate] = useState('');
  const [newReportDescription, setNewReportDescription] = useState('');

  // Load reports from backend
  const loadReports = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getReports(
        typeFilter,
        statusFilter,
        formatFilter,
        searchTerm || undefined,
        page + 1,
        rowsPerPage
      );

      if (response.success) {
        setReports(response.reports);
        setFilteredReports(response.reports);
        setStats(response.stats);
      } else {
        setError('Failed to load reports');
      }
    } catch (err: any) {
      console.error('Error loading reports:', err);
      setError(err.response?.data?.message || err.message || 'Failed to load reports');
    } finally {
      setLoading(false);
    }
  };

  // Load reports on mount and when filters change
  useEffect(() => {
    loadReports();
  }, [page, rowsPerPage, typeFilter, statusFilter, formatFilter]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchTerm || (!searchTerm && reports.length > 0)) {
        loadReports();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed': return <CheckCircleIcon style={{ color: '#4CAF50' }} />;
      case 'generating': return <PendingIcon style={{ color: '#FF9800' }} />;
      case 'failed': return <ErrorIcon style={{ color: '#F44336' }} />;
      case 'scheduled': return <ScheduleIcon style={{ color: '#2196F3' }} />;
      default: return <PendingIcon style={{ color: '#9E9E9E' }} />;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed': return '#4CAF50';
      case 'generating': return '#FF9800';
      case 'failed': return '#F44336';
      case 'scheduled': return '#2196F3';
      default: return '#9E9E9E';
    }
  };

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'analytics': return <AnalyticsIcon style={{ fontSize: '16px' }} />;
      case 'financial': return <MoneyIcon style={{ fontSize: '16px' }} />;
      case 'performance': return <TrendingUpIcon style={{ fontSize: '16px' }} />;
      case 'custom': return <CreateIcon style={{ fontSize: '16px' }} />;
      default: return <ReportIcon style={{ fontSize: '16px' }} />;
    }
  };

  const getFormatIcon = (format: string) => {
    switch (format) {
      case 'pdf': return <PdfIcon style={{ fontSize: '16px' }} />;
      case 'excel': return <TableIcon style={{ fontSize: '16px' }} />;
      case 'csv': return <TableIcon style={{ fontSize: '16px' }} />;
      case 'json': return <FileIcon style={{ fontSize: '16px' }} />;
      default: return <FileIcon style={{ fontSize: '16px' }} />;
    }
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, report: Report) => {
    setAnchorEl(event.currentTarget);
    setSelectedReport(report);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedReport(null);
  };

  const handleViewReport = async () => {
    const reportToView = selectedReport;
    if (!reportToView) {
      handleMenuClose();
      return;
    }

    // Close menu first
    setAnchorEl(null);

    try {
      setLoading(true);
      setError(null);
      const response = await getReport(reportToView.id);
      if (response.success) {
        setSelectedReport(response.report);
        setViewDialogOpen(true);
      } else {
        setError('Failed to load report details');
        setSelectedReport(null);
      }
    } catch (err: any) {
      console.error('Error loading report details:', err);
      setError(err.response?.data?.message || 'Failed to load report details');
      setSelectedReport(null);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleFavorite = async (reportId: string) => {
    try {
      const response = await toggleFavorite(reportId);
      if (response.success) {
        await loadReports(); // Reload to get updated data
      }
    } catch (err: any) {
      console.error('Error toggling favorite:', err);
      setError(err.response?.data?.message || 'Failed to update favorite status');
    }
  };

  const handleGenerateReport = async () => {
    if (!newReportTitle || !newReportType || !newReportFormat || !newReportStartDate || !newReportEndDate) {
      setError('Please fill in all report details before generating.');
      return;
    }

    try {
      setIsGenerating(true);
      setError(null);

      const response = await generateReport(
        newReportTitle,
        newReportType,
        newReportFormat,
        newReportDescription || `Report generated from analytics between ${newReportStartDate} and ${newReportEndDate}.`,
        newReportStartDate,
        newReportEndDate
      );

      if (response.success) {
        setCreateDialogOpen(false);
        setNewReportTitle('');
        setNewReportStartDate('');
        setNewReportEndDate('');
        setNewReportDescription('');
        setNewReportFormat('pdf');
        setNewReportType('analytics');
        
        // Reload reports
        await loadReports();
      } else {
        setError('Failed to generate report');
      }
    } catch (err: any) {
      console.error('Generate report error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to generate report. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleDownloadReport = async (reportId: string, format: 'pdf' | 'excel' | 'csv' | 'json') => {
    try {
      setError(null);
      const report = reports.find(r => r.id === reportId);
      
      if (!report) {
        setError('Report not found');
        return;
      }

      const data = await downloadReport(reportId, format);

      // Create downloadable file based on format
      let blob: Blob;
      let fileExtension: string;

      switch (format) {
        case 'pdf':
          blob = data instanceof Blob ? data : new Blob([data], { type: 'application/pdf' });
          fileExtension = 'pdf';
          break;
        case 'excel':
          blob = data instanceof Blob ? data : new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fileExtension = 'xlsx';
          break;
        case 'csv':
          let csvData: string;
          if (typeof data === 'string') {
            csvData = data;
          } else if (data instanceof Blob) {
            csvData = await data.text();
          } else {
            csvData = JSON.stringify(data);
          }
          blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
          fileExtension = 'csv';
          break;
        case 'json':
          const jsonData = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
          blob = new Blob([jsonData], { type: 'application/json;charset=utf-8;' });
          fileExtension = 'json';
          break;
        default:
          blob = data instanceof Blob ? data : new Blob([data], { type: 'application/octet-stream' });
          fileExtension = format;
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${report.title.replace(/\s+/g, '-').toLowerCase()}-${Date.now()}.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      // Reload to update download count
      await loadReports();
      handleMenuClose();
    } catch (err: any) {
      console.error('Download report error:', err);
      setError(err.response?.data?.message || err.message || 'Failed to download report');
    }
  };

  const handleDeleteReport = async (reportId: string) => {
    if (!window.confirm('Are you sure you want to delete this report?')) {
      return;
    }

    try {
      const response = await deleteReport(reportId);
      if (response.success) {
        await loadReports();
        handleMenuClose();
      } else {
        setError('Failed to delete report');
      }
    } catch (err: any) {
      console.error('Delete report error:', err);
      setError(err.response?.data?.message || 'Failed to delete report');
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Container maxWidth="xl" style={{ padding: '24px' }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <Typography variant="h4" style={{ fontWeight: 'bold', color: '#0927eb', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <ReportIcon style={{ fontSize: '32px' }} />
          Reports
        </Typography>
        <Typography variant="body1" style={{ color: '#666' }}>
          Generate and manage comprehensive reports and analytics
        </Typography>
      </div>

      {/* Refresh Button */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={loadReports}
          disabled={loading}
        >
          Refresh
        </Button>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={3} style={{ marginBottom: '32px' }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px' }}>
            <CardContent>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <Typography variant="h4" style={{ fontWeight: 'bold', color: '#0927eb' }}>
                    {stats.total}
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Total Reports
                  </Typography>
                </div>
                <ReportIcon style={{ fontSize: '40px', color: '#0927eb', opacity: 0.3 }} />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px' }}>
            <CardContent>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <Typography variant="h4" style={{ fontWeight: 'bold', color: '#4CAF50' }}>
                    {stats.completed}
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Completed
                  </Typography>
                </div>
                <CheckCircleIcon style={{ fontSize: '40px', color: '#4CAF50', opacity: 0.3 }} />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px' }}>
            <CardContent>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <Typography variant="h4" style={{ fontWeight: 'bold', color: '#FF9800' }}>
                    {stats.totalDownloads}
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Total Downloads
                  </Typography>
                </div>
                <DownloadIcon style={{ fontSize: '40px', color: '#FF9800', opacity: 0.3 }} />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card style={{ borderRadius: '12px' }}>
            <CardContent>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <Typography variant="h4" style={{ fontWeight: 'bold', color: '#2196F3' }}>
                    {stats.favorites}
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Favorites
                  </Typography>
                </div>
                <StarIcon style={{ fontSize: '40px', color: '#2196F3', opacity: 0.3 }} />
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {loading && (
        <Box sx={{ mb: 2 }}>
          <LinearProgress />
        </Box>
      )}

      {/* Error state */}
      {error && (
        <Box mb={2}>
          <Alert severity="error" onClose={() => setError(null)}>{error}</Alert>
        </Box>
      )}

      {/* Filters and Search */}
      <Paper style={{ padding: '24px', marginBottom: '24px', borderRadius: '12px' }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              placeholder="Search reports..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                label="Type"
              >
                <MenuItem value="all">All Types</MenuItem>
                <MenuItem value="analytics">Analytics</MenuItem>
                <MenuItem value="financial">Financial</MenuItem>
                <MenuItem value="performance">Performance</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status"
              >
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="generating">Generating</MenuItem>
                <MenuItem value="failed">Failed</MenuItem>
                <MenuItem value="scheduled">Scheduled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={formatFilter}
                onChange={(e) => setFormatFilter(e.target.value)}
                label="Format"
              >
                <MenuItem value="all">All Formats</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="csv">CSV</MenuItem>
                <MenuItem value="json">JSON</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              fullWidth
              onClick={() => {
                setError(null);
                setCreateDialogOpen(true);
              }}
              style={{
                backgroundColor: '#000000',
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              Generate Report
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Reports Table */}
      <TableContainer component={Paper} style={{ borderRadius: '12px' }}>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
              <TableCell style={{ fontWeight: 'bold' }}>Report</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Format</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Created By</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Date Range</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && filteredReports.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" style={{ padding: '40px' }}>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    Loading reports...
                  </Typography>
                </TableCell>
              </TableRow>
            ) : filteredReports.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" style={{ padding: '40px' }}>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    No reports found. Generate a new report to get started.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredReports
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((report) => (
                <TableRow key={report.id} hover>
                  <TableCell>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                        <Typography variant="subtitle2" style={{ fontWeight: 'bold', flex: 1 }}>
                          {report.title}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => handleToggleFavorite(report.id)}
                        >
                          {report.isFavorite ? (
                            <StarIcon style={{ color: '#FF9800', fontSize: '20px' }} />
                          ) : (
                            <StarBorderIcon style={{ color: '#666', fontSize: '20px' }} />
                          )}
                        </IconButton>
                      </div>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: '4px' }}>
                        {report.description}
                      </Typography>
                      <div>
                        {report.tags.map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag}
                            size="small"
                            style={{ marginRight: '4px', marginBottom: '2px' }}
                          />
                        ))}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {getTypeIcon(report.type)}
                      <Typography variant="body2" style={{ textTransform: 'capitalize' }}>
                        {report.type}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Chip
                      icon={getStatusIcon(report.status)}
                      label={report.status.charAt(0).toUpperCase() + report.status.slice(1)}
                      style={{
                        backgroundColor: getStatusColor(report.status),
                        color: 'white',
                        fontWeight: 'bold'
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {getFormatIcon(report.format)}
                      <Typography variant="body2" style={{ textTransform: 'uppercase' }}>
                        {report.format}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Avatar style={{ width: '24px', height: '24px', fontSize: '12px' }}>
                        {report.createdBy.split(' ').map(n => n[0]).join('')}
                      </Avatar>
                      {report.createdBy}
                    </div>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {new Date(report.dataRange.startDate).toLocaleDateString()} - {new Date(report.dataRange.endDate).toLocaleDateString()}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={(e) => handleMenuClick(e, report)}
                      size="small"
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredReports.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* Action Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleViewReport}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View Details</ListItemText>
        </MenuItem>
        {selectedReport?.status === 'completed' && (
          <MenuItem onClick={() => selectedReport && handleDownloadReport(selectedReport.id, selectedReport.format)}>
            <ListItemIcon>
              <DownloadIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Download</ListItemText>
          </MenuItem>
        )}
        <Divider />
        <MenuItem onClick={() => selectedReport && handleDeleteReport(selectedReport.id)} style={{ color: '#F44336' }}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" style={{ color: '#F44336' }} />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>

      {/* View Report Dialog */}
      <Dialog
        open={viewDialogOpen}
        onClose={() => {
          setViewDialogOpen(false);
          setSelectedReport(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h5" style={{ fontWeight: 'bold' }}>
            {selectedReport?.title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
              <CircularProgress />
            </Box>
          ) : selectedReport ? (
            <div style={{ marginTop: '16px' }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Report Information
                  </Typography>
                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '4px' }}>
                      Type
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {getTypeIcon(selectedReport.type)}
                      <Typography variant="subtitle2" style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                        {selectedReport.type}
                      </Typography>
                    </div>
                  </div>
                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '4px' }}>
                      Status
                    </Typography>
                    <Chip
                      icon={getStatusIcon(selectedReport.status)}
                      label={selectedReport.status.charAt(0).toUpperCase() + selectedReport.status.slice(1)}
                      style={{
                        backgroundColor: getStatusColor(selectedReport.status),
                        color: 'white',
                        fontWeight: 'bold'
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '4px' }}>
                      Format
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {getFormatIcon(selectedReport.format)}
                      <Typography variant="subtitle2" style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                        {selectedReport.format}
                      </Typography>
                    </div>
                  </div>
                  <div style={{ marginBottom: '16px' }}>
                    <Typography variant="body2" style={{ color: '#666', marginBottom: '4px' }}>
                      Created By
                    </Typography>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                      {selectedReport.createdBy}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Metrics Summary
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Paper style={{ padding: '12px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#0927eb' }}>
                          {(selectedReport.metrics?.totalViews || 0).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          Total Views
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <Paper style={{ padding: '12px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#4CAF50' }}>
                          {(selectedReport.metrics?.totalClicks || 0).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          Total Clicks
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <Paper style={{ padding: '12px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#FF9800' }}>
                          {(selectedReport.metrics?.totalShares || 0).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          Total Shares
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <Paper style={{ padding: '12px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#2196F3' }}>
                          ${(selectedReport.metrics?.totalRevenue || 0).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          Total Revenue
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <Paper style={{ padding: '12px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#9C27B0' }}>
                          {(selectedReport.metrics?.totalCampaigns || 0).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          Total Campaigns
                        </Typography>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <Paper style={{ padding: '12px', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ fontWeight: 'bold', color: '#F44336' }}>
                          {(selectedReport.metrics?.totalPRs || 0).toLocaleString()}
                        </Typography>
                        <Typography variant="body2" style={{ color: '#666' }}>
                          Total PRs
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Date Range
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    {new Date(selectedReport.dataRange.startDate).toLocaleDateString()} - {new Date(selectedReport.dataRange.endDate).toLocaleDateString()}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Description
                  </Typography>
                  <Typography variant="body2" style={{ color: '#666' }}>
                    {selectedReport.description || 'No description provided.'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Tags
                  </Typography>
                  <div>
                    {selectedReport.tags && selectedReport.tags.length > 0 ? (
                      selectedReport.tags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag}
                          size="small"
                          style={{ marginRight: '8px', marginBottom: '4px' }}
                        />
                      ))
                    ) : (
                      <Typography variant="body2" style={{ color: '#999', fontStyle: 'italic' }}>
                        No tags
                      </Typography>
                    )}
                  </div>
                </Grid>
                {selectedReport.sharedWith && selectedReport.sharedWith.length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                      Shared With
                    </Typography>
                    <List dense>
                      {selectedReport.sharedWith.map((email, index) => (
                        <ListItem key={index}>
                          <ListItemText primary={email} />
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                )}
              </Grid>
            </div>
          ) : (
            <Box sx={{ padding: '40px', textAlign: 'center' }}>
              <Typography variant="body2" style={{ color: '#666' }}>
                No report data available
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)}>
            Close
          </Button>
          {selectedReport?.status === 'completed' && (
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={() => selectedReport && handleDownloadReport(selectedReport.id, selectedReport.format)}
              style={{
                backgroundColor: '#000000',
                color: 'white'
              }}
            >
              Download Report
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Create Report Dialog */}
      <Dialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="h5" style={{ fontWeight: 'bold' }}>
            Generate New Report
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} style={{ marginTop: '16px' }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Report Title"
                placeholder="Enter report title"
                value={newReportTitle}
                onChange={(e) => setNewReportTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Report Type</InputLabel>
                <Select
                  label="Report Type"
                  value={newReportType}
                  onChange={(e) => setNewReportType(e.target.value as any)}
                >
                  <MenuItem value="analytics">Analytics Report</MenuItem>
                  <MenuItem value="financial">Financial Report</MenuItem>
                  <MenuItem value="performance">Performance Report</MenuItem>
                  <MenuItem value="custom">Custom Report</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Start Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={newReportStartDate}
                onChange={(e) => setNewReportStartDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="End Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={newReportEndDate}
                onChange={(e) => setNewReportEndDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Output Format</InputLabel>
                <Select
                  label="Output Format"
                  value={newReportFormat}
                  onChange={(e) => setNewReportFormat(e.target.value as any)}
                >
                  <MenuItem value="pdf">PDF</MenuItem>
                  <MenuItem value="excel">Excel</MenuItem>
                  <MenuItem value="csv">CSV</MenuItem>
                  <MenuItem value="json">JSON</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                multiline
                rows={3}
                placeholder="Enter report description"
                value={newReportDescription}
                onChange={(e) => setNewReportDescription(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            startIcon={<ReportIcon />}
            disabled={isGenerating}
            onClick={handleGenerateReport}
            style={{
              backgroundColor: '#000000',
              color: 'white'
            }}
          >
            {isGenerating ? 'Generating...' : 'Generate Report'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Reports;